import { render, staticRenderFns } from "./AcademyTopOffer.vue?vue&type=template&id=a8a3493c&scoped=true&"
import script from "./AcademyTopOffer.vue?vue&type=script&lang=js&"
export * from "./AcademyTopOffer.vue?vue&type=script&lang=js&"
import style0 from "./AcademyTopOffer.vue?vue&type=style&index=0&id=a8a3493c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a3493c",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardTitle, BCardText, BButton, BCardBody, BCard} from 'bootstrap-vue'
    installComponents(component, {BCardTitle, BCardText, BButton, BCardBody, BCard})
    

export default component.exports